<template>
    <div id="app">
        <router-view />
    </div>
</template>
<script>
import UserEventRecord from '@/api/copyright/userEventRecord'
import { mapMutations } from "vuex";
export default {
    data(){
        return{
            path:'',
        }
    },
    watch: {
        //监听相同路由下参数变化的时候，从而实现异步刷新
        '$route'(to,from) {
            // if(this.$route.path!=='/'){//灰化处理解除
            //     setTimeout(() => {
            //         document.getElementsByTagName("html")[0].removeAttribute("class","gray");
            //     }, 1000);
            // };
            this.path=this.$route.path;
            this.frameSelf();
        },
    },
    created(){
        window.addEventListener("message",(event)=>{
            if(event.data!=='undefined' && typeof(event.data)=='string'){
                let path=JSON.parse(event.data)?.routerPath;
                if(path){
                    this.$router.push({
                        path
                    })
                }
            }
        },false)
    },
    mounted () {
        // 设置诸葛埋点初始化
        UserEventRecord.init()
        this.$TsaIframeDialog.init({
            //src: 'http://local.tsatest.cn:1230/common/detailDrawer',
            src: process.env.VUE_APP_COPYRIGHT_PC + '/common/detailDrawer?newTime='+ new Date().getTime()
        })
        this.setParentIframe()
    },
    methods: {
        ...mapMutations({
            setParentIframe: 'app/setParentIframe',
        }),
        frameSelf(){
            // 判断当前页面在iframe中,避免自己嵌自己的情况
            if (self!=top) {
                window.parent.postMessage(JSON.stringify({'routerPath':this.path}) , '*');
            }
        },
    }

};
</script>
<style lang="scss">
.timestampR{
    font-style: normal;
    list-style: none;
    font-family: '黑体','SimHei','Arial',sans-serif,'微软雅黑';
    font-weight: 400;
    sup{
        list-style: none;
        font-family: '黑体','SimHei';
        font-weight: 400;
    }
}
.el-scrollbar{
    > .el-scrollbar__bar{
        opacity: 1 !important;
    }
}
.el-dropdown-menu {
    &.tsa-custom-dropdown-menu {
        padding: 0;
        margin: 0;
        margin-top: 8px!important;
        padding-bottom: 12px;
        min-width: 76px;
        .el-dropdown-menu__item {
            font-size: 11px;
            color: #333333;
            line-height: normal;
            margin-top: 12px;
            padding: 0;
            text-align: center;
        }
    }
}
.el-popover {
    &.table-popper {
        padding: 4px 0 4px 0;
        background: #FFFFFF;
        box-shadow: 0px 2px 8px 0px rgba(7,12,20,0.12);
        border-radius: 4px;
        // z-index: 99!important;
        min-width: max-content;
        .table-popper-content {
            .item {
                height: 32px;
                line-height: 32px;
                font-size: 14px;
                color: #151B26;
                padding: 0 12px;
                cursor: pointer;
                &:hover {
                    background-color: #E6F0FF;
                }
                &.active {
                    background-color: #E6F0FF;
                }
                &.disabled {
                    cursor: not-allowed;
                    color: #999999;
                    &:hover {
                        background-color: #FFFFFF;
                    }
                }
            }
        }
        .popper__arrow {
            display: none;
        }
    }
}
.table-action-container {
    display: flex;
    justify-content: center;
    align-items: center;
    .table-actiob-btn {
        font-size: 14PX;
        color: #0047FF;
        margin-right: 15PX;
        cursor: pointer;
        &:last-child {
            margin-right: 0!important;
        }
    }
}
.myShadowTooltip{
    background: #fff !important;
    box-shadow: 0px 3px 10px 1px rgba(0, 0, 0, 0.1);
    color: #000 !important;
}
.myShadowTooltip[x-placement^="top"] .popper__arrow {
    border-top-color: #fff !important;
    filter: box-shadow(0px 3px 10px 1px rgba(0, 0, 0, 0.1));
}
  
.myShadowTooltip[x-placement^="top"] .popper__arrow:after {
    border-top-color:#fff !important;
}
  
.myShadowTooltip[x-placement^="bottom"] .popper__arrow { 
    border-bottom-color: #fff !important;
    filter: box-shadow(0px 3px 10px 1px rgba(0, 0, 0, 0.1));
}
  
.myShadowTooltip[x-placement^="bottom"] .popper__arrow:after {
    border-bottom-color:#fff !important;
}
</style>
